import React from 'react';
import './CampaignSingle.css';

import { Button, Lightbox, PageTitle, SidebarHeading } from '../../../components';
import { campaigns } from '../../../constants';

import { FaCircleNotch } from 'react-icons/fa';

import { Link, useLocation } from 'react-router-dom';



const CampaignSingle = () => {

  // Get campaign details passed via router state
  const location = useLocation();
  const campaign = location.state;

  // Extract the amount raised and goal
  const raised = campaign.donation.raised;
  const goal = campaign.donation.goal;

  // Calculate the percentage of the goal that has been raised
  const percentage = (raised / goal) * 100;

  // Round the calculated percentage to the nearest whole number for display
  const displayPercentage = Math.round(percentage);

  return (
    <>
      {/* Page Title Section */}
      <PageTitle title={campaign.title} page={"Campaign Single"} />

      <section className='campaign-single page-single'>

        <div className='campaign-info page-info'>

          {/* Campaign Image */}
          <div className='image'>
            <img src={campaign.image} alt={campaign.title} />
          </div>

          <div className='content'>

            <div className='intro'>

              {/* Campaign Title */}
              <h3 className='main-heading'>{campaign.title}</h3>

              {/* Progress bar showing donation progress */}
              <div className="skill-bar">
                <span className="skill-progress" style={{ width: `${displayPercentage}%` }}> {/* Filled portion of the progress bar */}
                  <span className="skill-no">{displayPercentage}%</span> {/* Display percentage number inside the progress bar */}
                </span>
              </div>

              {/* Raised amount and Goal amount */}
              <div className='amount'>
                <p><span>${campaign.donation.raised}</span> Raised</p>
                <p><span>${campaign.donation.goal}</span> Goal</p>
              </div>

              {/* Donate button linking to the donation page */}
              <Button link={'Donation'} title={'Donate Now'} />

            </div>

            <div className='sub-section'>

              <h3 className='sub-heading'>Campaign Overview:</h3>

              {/* Campaign Description */}
              {campaign.paragraphs.map((paragraph, index) => (
                <p key={index}>
                  {paragraph}
                </p>
              ))}

            </div>

            {/* Campaign Image Gallery */}
            <Lightbox images={campaign.gallery} />

            {/* Objectives & Mission Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Objectives & Mission:</h3>

              <p>Explore a variety of room types and enjoy features designed for comfort and convenience:</p>

              {/* List of Objectives */}
              <ul>
                {campaign.objectives.map((objective, index) => {
                  return <li key={index}><FaCircleNotch className='icon' />{objective}</li>
                })}
              </ul>

            </div>

            {/* Impact and Result Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Impact and Result:</h3>

              {campaign.results.map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}

            </div>

          </div>

        </div>

        <div className='sidebar campaign-sidebar'>

          <div className='sidebar-item'>

            <SidebarHeading title='All Campaigns' />

            <div className='box-container'>
              {/* Loop through all campaign items and render each one */}
              {campaigns.map((item) => { 
                return(
                  <div className='post-item' key={item.id}> 
                    <img src={item.image} alt={item.title} />
                    <div className='content'>
                      <Link
                        to={`/Campaigns/${item.title}`}
                        state={item}
                        className='main-heading'
                      >
                        {item.title}
                      </Link>
                    </div>
                  </div>
                )

              })}
            </div>

          </div>

        </div>

      </section>

    </> 
  );
}

export default CampaignSingle;